<template>
    <BaseBadge
        :theme="theme"
        :size="size"
        :is-floating="isFloating"
        :class="{
            'flex items-center justify-center font-mono': true,
            'size-5 text-2xs': size === BadgeSize.Small,
            'size-6 text-xs': size === BadgeSize.Normal,
            'size-7 text-sm': size === BadgeSize.Large,
        }"
    >
        <slot />
    </BaseBadge>
</template>

<script lang="ts" setup>
import { defineProps, withDefaults } from 'vue';
import { BadgeSize, BadgeTheme } from '@/types';

interface Props {
    theme?: BadgeTheme;
    size?: BadgeSize;
    isFloating?: boolean;
}

withDefaults(defineProps<Props>(), {
    theme: BadgeTheme.Primary,
    size: BadgeSize.Normal,
    isFloating: false,
});
</script>
